import React, { Component } from "react";
import { connect } from "react-redux";
import { updateDumper, deleteDumper } from "../actions/dumpers";
import DumpersDataService from "../services/dumper.service";
import UploadService from "../services/dumper.service";

class Dumper extends Component {
  constructor(props) {
    super(props);
    this.onChangeNom = this.onChangeNom.bind(this);
    this.onChangeVolumeM = this.onChangeVolumeM.bind(this);
    this.onChangeChargeM= this.onChangeChargeM.bind(this);

    this.getDumper = this.getDumper.bind(this);
    this.removeDumper = this.removeDumper.bind(this);

    this.state = {
      currentDumper: {
        id: null,
        Nom: "",
        Charge_max:"",
        Volume_max:"",
        Img1:"",
        Img2:"",
        Img3:"",
        Fiche_technique: "",
        published:false,
      },
      message: "",
      selectedFiles1: undefined,
      selectedFiles2: undefined,
      selectedFiles3: undefined,
      selectedFiles4: undefined,
      progress: 0,
      fileName:"",
      progress2: 0,
      fileName2:"",
      progress3: 0,
      fileName3:"",
      progress4: 0,
      fileName4:"",
      fileInfos: [],

    };
  }

  componentDidMount() {
    this.getDumper(this.props.match.params.id);
  }

  onChangeNom(e) {
    const Nom = e.target.value;

    this.setState(function (prevState) {
      return {
        currentDumper: {
          ...prevState.currentDumper,
          Nom: Nom,
        },
      };
    });
  }

  onChangeVolumeM(e) {
    const Volume_max = e.target.value;

    this.setState(function (prevState) {
      return {
        currentDumper: {
          ...prevState.currentDumper,
          Volume_max: Volume_max,
        },
      };
    });
  }

  onChangeChargeM(e) {
    const Charge_max = e.target.value;

    this.setState(function (prevState) {
      return {
        currentDumper: {
          ...prevState.currentDumper,
          Charge_max: Charge_max,
        },
      };
    });
  }

  selectFile1 =(event) =>{
    this.setState({
          selectedFiles1: event.target.files,
        }
    );
  }

  selectFile2 =(event) =>{
    this.setState({
          selectedFiles2: event.target.files,
        }
    );
  }

  upload = () => {


    if (this.state.selectedFiles1) {
      if ((this.state.selectedFiles1).length < 3) {
        this.setState({
          message: "Veuillez selectionner 3 images !",
        })
      }

      if ((this.state.selectedFiles1).length === 3) {

        if (this.state.selectedFiles1 && this.state.selectedFiles2) {
          let currentFile1 = this.state.selectedFiles1[0];
          let currentFile2 = this.state.selectedFiles1[1];
          let currentFile3 = this.state.selectedFiles1[2];
          let currentFile4 = this.state.selectedFiles2[0];
          let fileName1 = 'https://api.attirail.fr/api/fichierdumpers/files/' + currentFile1.name;
          let fileName2 = 'https://api.attirail.fr/api/fichierdumpers/files/' + currentFile2.name;
          let fileName3 = 'https://api.attirail.fr/api/fichierdumpers/files/' + currentFile3.name;
          let fileName4 = 'https://api.attirail.fr/api/fichierdumpers/files/' + currentFile4.name;
          var files = [currentFile1, currentFile2, currentFile3, currentFile4];
          this.setState({
            progress: 0,
            currentFile1: currentFile1,
            currentFile2: currentFile2,
            currentFile3: currentFile3,
            currentFile4: currentFile4,
          });
          this.setState(function (prevState) {
            return {
              currentDumper: {
                ...prevState.currentDumper,
                Img1: fileName1,
                Img2: fileName2,
                Img3: fileName3,
                Fiche_technique: fileName4,

              },
            };
          });

          UploadService.upload(files, (event) => {
            this.setState({
              progress: Math.round((100 * event.loaded) / event.total),
            });
          }).then((response) => {
            this.setState({
                  message: response.data.message,
                }
            );
            return UploadService.getFiles();
          })
              .then((files) => {
                this.setState({
                  fileInfos: files.data,
                });
              }).then(() => {
            this.props
                .updateDumper(this.state.currentDumper.id, this.state.currentDumper)
                .then((response) => {
                  console.log(response);

                  this.setState({message: "The dumper was updated successfully!"});
                })
                .catch((e) => {
                  console.log(e);
                });
          })
              .catch(() => {
                this.setState({
                  progress: 0,
                  message: "Could not upload the file!",
                  currentFile: undefined,
                });
              });


          this.setState({
            selectedFiles1: undefined,
            selectedFiles2: undefined,

          });

        }


        if (this.state.selectedFiles2) {
          let currentFile4 = this.state.selectedFiles2[0];
          let fileName4 = 'https://api.attirail.fr/api/fichierdumpers/files/' + currentFile4.name;

          this.setState({
            progress: 0,

            currentFile4: currentFile4,
          });
          this.setState(function (prevState) {
            return {
              currentDumper: {
                ...prevState.currentDumper,
                Fiche_technique: fileName4,

              },
            };
          });

          UploadService.upload(currentFile4, (event) => {
            this.setState({
              progress: Math.round((100 * event.loaded) / event.total),
            });
          }).then((response) => {
            this.setState({
                  message: response.data.message,
                }
            );
            return UploadService.getFiles();
          })
              .then((files) => {
                this.setState({
                  fileInfos: files.data,
                });
              }).then(() => {
            this.props
                .updateDumper(this.state.currentDumper.id, this.state.currentDumper)
                .then((response) => {
                  console.log(response);

                  this.setState({message: "The dumper was updated successfully!"});
                })
                .catch((e) => {
                  console.log(e);
                });
          })
              .catch(() => {
                this.setState({
                  progress: 0,
                  message: "Could not upload the file!",
                  currentFile: undefined,
                });
              });


          this.setState({
            selectedFiles2: undefined,
          });

        }

        if (this.state.selectedFiles1 && !this.state.selectedFiles2) {
          let currentFile1 = this.state.selectedFiles1[0];
          let currentFile2 = this.state.selectedFiles1[1];
          let currentFile3 = this.state.selectedFiles1[2];

          let fileName1 = 'https://api.attirail.fr/api/fichierdumpers/files/' + currentFile1.name;
          let fileName2 = 'https://api.attirail.fr/api/fichierdumpers/files/' + currentFile2.name;
          let fileName3 = 'https://api.attirail.fr/api/fichierdumpers/files/' + currentFile3.name;

          var files = [currentFile1, currentFile2, currentFile3];
          this.setState({
            progress: 0,
            currentFile1: currentFile1,
            currentFile2: currentFile2,
            currentFile3: currentFile3,

          });
          this.setState(function (prevState) {
            return {
              currentDumper: {
                ...prevState.currentDumper,
                Img1: fileName1,
                Img2: fileName2,
                Img3: fileName3,


              },
            };
          });

          UploadService.upload(files, (event) => {
            this.setState({
              progress: Math.round((100 * event.loaded) / event.total),
            });
          }).then((response) => {
            this.setState({
                  message: response.data.message,
                }
            );
            return UploadService.getFiles();
          })
              .then((files) => {
                this.setState({
                  fileInfos: files.data,
                });
              }).then(() => {
            this.props
                .updateDumper(this.state.currentDumper.id, this.state.currentDumper)
                .then((response) => {
                  console.log(response);

                  this.setState({message: "The dumper was updated successfully!"});
                })
                .catch((e) => {
                  console.log(e);
                });
          })
              .catch(() => {
                this.setState({
                  progress: 0,
                  message: "Could not upload the file!",
                  currentFile: undefined,
                });
              });


          this.setState({
            selectedFiles1: undefined,
          });

        }



        this.setState(function (prevState) {
          return {
            currentDumper: {
              ...prevState.currentDumper,
              published: true,
            },
          };
        })

      }




    }
    if (!this.state.selectedFiles1 && !this.state.selectedFiles2) {
      this.props
          .updateDumper(this.state.currentDumper.id, this.state.currentDumper)
          .then((response) => {
            console.log(response);

            this.setState({message: "The dumper was updated successfully!"});
          })
          .catch((e) => {
            console.log(e);
          });

      this.setState(function (prevState) {
        return {
          currentDumper: {
            ...prevState.currentDumper,
            published: true,
          },
        };
      })
    }

    if (!this.state.selectedFiles1 && this.state.selectedFiles2) {

      let currentFile4 = this.state.selectedFiles2[0];

      let fileName4 = 'https://api.attirail.fr/api/fichierdumpers/files/' + currentFile4.name;
      var files = [ currentFile4];
      this.setState({
        progress: 0,

      });
      this.setState(function (prevState) {
        return {
          currentDumper: {
            ...prevState.currentDumper,
            Fiche_technique: fileName4,

          },
        };
      });

      UploadService.upload(files, (event) => {
        this.setState({
          progress: Math.round((100 * event.loaded) / event.total),
        });
      }).then((response) => {
        this.setState({
              message: response.data.message,
            }
        );
        return UploadService.getFiles();
      })
          .then((files) => {
            this.setState({
              fileInfos: files.data,
            });
          }).then(() => {
        this.props
            .updateChenillard(this.state.currentDumper.id, this.state.currentDumper)
            .then((response) => {
              console.log(response);

              this.setState({message: "The dumper was updated successfully!"});
            })
            .catch((e) => {
              console.log(e);
            });
      })
          .catch(() => {
            this.setState({
              progress: 0,
              message: "Could not upload the file!",
              currentFile: undefined,
            });
          });


      this.setState({
        selectedFiles1: undefined,
        selectedFiles2: undefined,

      });

      this.setState(function (prevState) {
        return {
          currentChenillard: {
            ...prevState.currentChenillard,
            published: true,
          },
        };
      })
    }



  }






  getDumper(id) {
    DumpersDataService.get(id)
      .then((response) => {
        this.setState({
          currentDumper: response.data,
        });
        console.log(response.data);
      })
      .catch((e) => {
        console.log(e);
      });
  }


  removeDumper() {
    this.props
      .deleteDumper(this.state.currentDumper.id)
      .then(() => {
        this.props.history.push("/dumpers");
      })
      .catch((e) => {
        console.log(e);
      });
  }

  render() {
    const { currentDumper , currentFile1, currentFile2, currentFile3, currentFile4,progress,
      message} = this.state;

    return (
        <div>
          {currentDumper ? (
              <div>
                {!currentDumper.published && (
                    <div>
                      <div className="edit-form">
                        <div>
                          <h4>Mise à jour de : {currentDumper.Nom}</h4>
                          <form>
                            <div className="form-group">
                              <label htmlFor="Nom">Nom</label>
                              <input
                                  type="text"
                                  className="form-control"
                                  id="Nom"
                                  value={currentDumper.Nom}
                                  onChange={this.onChangeNom}
                              />
                              <label htmlFor="Charge_max">Charge Max</label>
                              <input
                                  type="text"
                                  className="form-control"
                                  id="Charge_max"
                                  value={currentDumper.Charge_max}
                                  onChange={this.onChangeChargeM}
                              />
                              <label htmlFor="Volume_max">Volume Max</label>
                              <input
                                  type="text"
                                  className="form-control"
                                  id="Volume_max"
                                  value={currentDumper.Volume_max}
                                  onChange={this.onChangeVolumeM}
                              />
                            </div>
                            <div>
                              {currentFile1 && currentFile2 && currentFile3 && currentFile4 && (
                                  <div className="progress">
                                    <div
                                        className="progress-bar progress-bar-info progress-bar-striped"
                                        role="progressbar"
                                        aria-valuenow={progress}
                                        aria-valuemin="0"
                                        aria-valuemax="100"
                                        style={{width: progress + "%"}}
                                    >
                                      {progress}%
                                    </div>
                                  </div>
                              )}
                              <p>Si mise à jour des images veuillez en mettre 3  </p>
                              <label className="btn btn-default">
                                <input type="file" max="3" multiple='3' encType='multipart/form-data' onChange={this.selectFile1}/>
                              </label>
                              <p>Fiche technique :
                              </p>
                              <label className="btn btn-default>">
                                <input type="file"  onChange={this.selectFile2}/>
                              </label>

                              <div className="alert alert-light" role="alert">
                                {message}
                              </div>


                            </div>

                            <div className="form-group">
                              <label>
                                <strong>Status:</strong>
                              </label>
                              {currentDumper.published ? "Published" : "En cours de modification"}
                            </div>
                          </form>

                        </div>

                        <button
                            className="badge badge-danger mr-2"
                            onClick={this.removeDumper}
                        >
                          Supprimer
                        </button>
                        <a
                            className="btn badge-success"
                            onClick={this.upload}
                        >
                          Mettre à jour
                        </a>
                      </div>

                    </div>   )}
                {currentDumper.published===true && (
                    <div>
                      <a
                          href="http://gestion.attirail.fr/dumpers"
                      >
                        Revenir à la liste des dumpers
                      </a>

                    </div>)}

              </div>

          ) : (
              <div>
                <br />
                <p>Erreur ce dumper n'éxiste pas</p>
                <a
                    href="http://gestion.attirail.fr/dumpers"
                >
                  Revenir à la liste des dumpers
                </a>
              </div>
          )
          }
        </div>
    );
  }
}

export default connect(null, { updateDumper, deleteDumper })(Dumper);
